import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  static targets = ['incrementSelect'];

  connect() {
    this.incrementSelectTargets.forEach((target) => {
      // eslint-disable-next-line no-new
      new TomSelect(target, {});
    });
  }
}
